import React, { useState, useEffect } from 'react';
// Navigation
import { useHistory, useLocation } from 'react-router-dom'
// Styles
import 'antd/dist/antd.css'
import '../dashboard.scss'
import { Card } from 'react-bootstrap';
import localStorage from "../../utils/localStorage";
// Mui Components
import Grid from '@material-ui/core/Grid';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { useTheme } from '@material-ui/core';
import Box from '@material-ui/core/Box';
// Custom components
import DashboardLayout from '../../layouts/dashboardLayout'
import { AppBar, Button, PaginationBar, Navbar, NavbarSearch, ConfirmationModal, Table } from '../../customComponents'
// Constants
import { AppImages } from '../../themes/appImages'
import { appConstants } from '../../themes/constants'
// utils methods
import { useStyles } from '../../styles'
// Redux
import { useSelector, useDispatch } from 'react-redux'
import { getImageListAction, handleNavigationStateAction, deleteImageAction } from '../../store/actions'
// Global constants


export const ImageListing = () => {
    const styleProps = { searchable: true }
    // Hooks declarations
    const classes = useStyles(styleProps);
    const history = useHistory();
    const dispatch = useDispatch()
    const theme = useTheme()
    const matches = useMediaQuery(theme.breakpoints.down('xs'));
    const imageManagementState = useSelector(state => state.imageManagementReducer)
    // Global state initialization
    const { imageListing, imagePaging, isTableDataLoading, deletedImage } = imageManagementState
    let permissionsData = localStorage?.getPermissions()
    let employeeIndex = permissionsData?.findIndex((x) => x.name == "image")
    let siderIndex = localStorage.getLayoutArr()
    // local state initialization
    const [search, setSearch] = useState("")
    const [offset, setOffset] = useState(0)
    const [limit, setLimit] = useState(10)
    const [sortBy, setSortBy] = useState("")
    const [order, setOrder] = useState(null)
    const [confirm, setConfirm] = useState(false)
    const [imageToDelete, setImageToDelete] = useState(null)
    const [disableButton, setDisableButton] = useState()
    // +++++++++++

    // Method to fetch listing
    const fetchDataListing = (search, offset, limit, sortBy, order) => {
        dispatch(getImageListAction(
            search, offset, limit, sortBy, order
        ))
    }
    //lifecycle hooks
    useEffect(() => {
        document.title = appConstants.headerTitle.imageListing;
        if (permissionsData) {
            let index = siderIndex?.findIndex((x) => x.key == "image")
            console.log(index, "index", siderIndex)
            dispatch(handleNavigationStateAction(index, false))
        }
        else {
            dispatch(handleNavigationStateAction(5, false))
        }

        fetchDataListing(search, offset, limit, sortBy, order)
    }, [])

    useEffect(() => {
        if (deletedImage !== null) {
            fetchDataListing(search, 0, limit, sortBy, order)
        }
    }, [deletedImage])

    //Callback method to handle sorting 
    const handleChange = async (pagination, filters, sorter) => {
        //To fetch listing in ascending order
        if (sorter.order == "ascend") {
            setOrder(1)
            setSortBy(sorter.columnKey)

            fetchDataListing(search, offset, limit, sorter.columnKey, 1)
        } //To fetch listing in descending order
        else if (sorter.order === "descend") {
            setOrder(-1)
            setSortBy(sorter.columnKey)

            fetchDataListing(search, offset, limit, sorter.columnKey, -1)
        } //To fetch listing in normal order
        else {
            setOrder(null)
            setSortBy("")

            fetchDataListing(search, offset, limit, "", null)
        }
    }

    // Callback method to handle page chage
    const handlePaginationChange = (e, page) => {
        const offsetTo = (page - 1) * limit
        setOffset(offsetTo)

        fetchDataListing(search, offsetTo, limit, sortBy, order)
    }

    // Callback method to handle searching key
    const handleSearching = async (e) => {

        var tempText = e.target.value
        if (e.target.value.charAt(0) === " ") {
            tempText = e.target.value.replace(/^ +/gm, '');
        }
        setSearch(tempText)
        fetchDataListing(tempText, 0, limit, "", null)
    }


    const columns = [
        {
            title: appConstants.sr,
            dataIndex: '',
            key: 'sr',
            render: (text, record, index) => (index + 1) + (imagePaging?.page?.nextPage - limit),
            ellipsis: false,
            width: 100,
        },
        {
            title: appConstants.imageName,
            dataIndex: 'image_name',
            key: 'image_name',
            render: (image_name) => <div className={classes.imageNameCell}>
                {image_name}
            </div>,
            ellipsis: false,
            sorter: true,
        },
        {
            title: appConstants.image,
            dataIndex: 'image_url',
            key: 'image_url',
            align: 'center',
            render: (image_url) => {
                return (
                    <div className={classes.listingLogo}>
                        {
                            image_url ?
                                <img src={appConstants.baseURL + image_url} className={classes.imageManagementLogo} /> :
                                // <img src={image_url} className={classes.imageManagementLogo} /> :
                                <img src={AppImages.logo} className={classes.imageManagementLogo} />
                        }
                    </div>
                )
            },
            ellipsis: false,
            width: 250,
        },
        {
            title: appConstants.action,
            dataIndex: '',
            key: 'x',
            width: 100,
            align: 'center',
            render: (text, record, index) => {
                return (
                    <Grid className={classes.buttons}>
                        <Button title={appConstants.delete}
                            disabled={(permissionsData) && permissionsData[employeeIndex]?.delete == false}
                            onClick={() => {
                                setConfirm(true)
                                setImageToDelete(record._id)
                                setDisableButton(false)
                            }} />
                    </Grid>
                )
            },
        },
    ];

    return (
        <DashboardLayout>
            <ConfirmationModal title={appConstants.alert} text={appConstants.confirmDeleteImage} visible={confirm}
                disable={disableButton}
                onCancel={() => {
                    setConfirm(false)
                }}
                onDeleteConfirmed={() => {
                    dispatch(deleteImageAction(imageToDelete))
                    setConfirm(false)
                    setDisableButton(true)
                }}
            />
            <AppBar breadcrumbs={[{ route: '/image-list', name: appConstants.imageManagement }]} />
            <Grid container className={classes.buttonBarWrapper} >
                <Button title={appConstants.addImage} disabled={(permissionsData) && permissionsData[employeeIndex]?.add == false} onClick={() => history.push('/add-image')} mr mb />
            </Grid>
            <Navbar title={appConstants.imageManagement} searchable value={search} onChange={(e) => handleSearching(e)} />
            <Card className={classes.card}>
                {matches &&
                    <Box className={classes.searchBox}>
                        <NavbarSearch value={search} onValueChange={(e) => handleSearching(e)} />
                    </Box>
                }
                <Grid container>
                    <Grid className={classes.tableContainerRow}> 
                        <Table
                            loading={isTableDataLoading}
                            columns={columns}
                            dataSource={imageListing}
                            onChange={handleChange}
                            searching={search.length > 0}
                        />
                    </Grid>
                </Grid>
                <PaginationBar
                    totalCount={imagePaging?.page?.totalCount}
                    count={Math.ceil(imagePaging?.page?.totalCount / limit)}
                    currentPage={imagePaging?.page?.currentPage}
                    nextPage={imagePaging?.page?.nextPage}
                    onChange={(e, page) => handlePaginationChange(e, page)}
                    prevPage={imagePaging?.page?.nextPage - limit}
                />
            </Card>
        </DashboardLayout>
    );
}
